import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme) => ({
    card: {
        marginTop: theme.spacing(3)
    },
    actionSkel: {
        marginRight: theme.spacing(2),
        display: 'inline-block'
    }
}));

export default function FeedItemLoading(props) {

    const classes = useStyles();

    return (
        <Card className={classes.card}>
            <CardHeader
                avatar={<Skeleton animation="wave" variant="circle" width={40} height={40} />}
                title={<Skeleton animation="wave" height={10} width="30%" style={{ marginBottom: 6 }} />}
                subheader={<Skeleton animation="wave" height={10} width="20%" />}
            />
            <CardContent>
                <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} />
                <Skeleton animation="wave" height={10} width="80%" />
            </CardContent>
            <CardActions>
                <Grid container justify="space-between" alignItems="center">
                    <Grid item>
                        <Skeleton
                            className={classes.actionSkel}
                            animation="wave"
                            variant="rect"
                            width={34}
                            height={34}
                        />
                        <Skeleton
                            className={classes.actionSkel}
                            animation="wave"
                            variant="rect"
                            width={34}
                            height={34}
                        />
                    </Grid>
                    <Grid item>
                        <Skeleton animation="wave" variant="rect" width={88} height={20} />
                    </Grid>
                </Grid>
            </CardActions>
        </Card>
    );
}
